import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { orderBy } from "@progress/kendo-data-query";
import { Grid as DataGrid, GridColumn } from "@progress/kendo-react-grid";
import { Grid } from "@mui/material";
import EditButtonCell from "../edit-button-cell";
import {
  USER_CASEDESIGNER,
  USER_CONCIERGE,
  USER_FINANCIALPROFESSIONAL,
  USER_SUPERADMIN,
} from "../../shared/constants";
import SettingsIcon from '@mui/icons-material/Settings';

const SettingsCell = (handleClick) => (props) => {
  const { dataItem } = props;

  return <td>
    <SettingsIcon onClick={() => {
      handleClick(dataItem);
    }} />
  </td>
};

const IFWUserList = (props) => {
  const [state, setState] = useState({
    showFinancialProModal: false,
    sort: [
      {
        field: "firstName",
        dir: "asc",
      },
    ],
    page: { skip: 0, take: 10 },
  });

  const getRoleString = (role) => {
    switch (role.toUpperCase()) {
      case USER_SUPERADMIN:
        return "Super Admin";
      case USER_CONCIERGE:
        return "Concierge";
      case USER_FINANCIALPROFESSIONAL:
        return "Financial Professional";
      case USER_CASEDESIGNER:
        return "Case Designer";
    }
  };

  const authorization = useSelector((state) =>
    state.dataStore.getIn(["currentUser", "authorization"]))

  const ifwUserData = useSelector((state) =>
    state.dataStore.getIn(["ifwUsers"])
  );

  const filterAdminUsers = (item) =>
    item.role === USER_CONCIERGE || item.role === USER_CASEDESIGNER;

  const filterFP = (item) => item.role === USER_FINANCIALPROFESSIONAL;

  const filterFPConcierge = (item) => props.fpBindingConcierge.includes(item.clientId)

  const ifwUsers = ifwUserData
    .toJS()
    .filter(props.isIFWList ? filterAdminUsers : authorization === USER_SUPERADMIN || authorization === USER_CASEDESIGNER ? filterFP : filterFPConcierge)
    .map((item) => {
      return {
        ...item,
        displayRole: getRoleString(item.role),
        createDate: new Date(item.createDate)
      };
    });

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <DataGrid
            scrollable={"none"}
            className={"ifw-datagrid"}
            sort={state.sort}
            data={orderBy(ifwUsers, state.sort).slice(
              state.page.skip,
              state.page.take + state.page.skip
            )}
            sortable={true}
            onSortChange={(e) => {
              setState({
                ...state,
                sort: e.sort,
              });
            }}
            skip={state.page.skip}
            take={state.page.take}
            total={ifwUsers.length}
            pageable={true}
            onPageChange={(event) => {
              setState({
                ...state,
                page: event.page,
              });
            }}
            onRowClick={(event) => {
              if (props.onRowClick) props.onRowClick(event);
            }}
          >
            <GridColumn title={"First Name"} field={"firstName"} />
            <GridColumn title={"Last Name"} field={"lastName"} />
            <GridColumn title={"Email"} field={"email"} />
            <GridColumn title={"Phone"} field={"phone"} />
            <GridColumn title={"Role"} field={"displayRole"} />
            <GridColumn
              title={"Create Date"}
              field={"createDate"}
              format="{0:d}"
            />
            <GridColumn title={" "} cell={EditButtonCell(props.edit)} />
            {authorization === USER_SUPERADMIN && <GridColumn title={" "} cell={SettingsCell(props.settings)} />}
          </DataGrid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default IFWUserList;
